<template>
  <stat-box :label="label"
            :value="12000"
            :bg-color="bgColor"
            :color="color"
            :label-color="labelColor"
            :css-class="cssClass"
            :icon="icon"
            :info="info"
            :size="size"
            :align="align"
            :divider="divider"
  >
    <div class="d-flex radio-stat-value">
      <span class="radio-value">{{ value }}</span>
      <b-form-radio
          v-model="checked"
          :value="radioValue"
          :name="radioName"
          class="mt-1 radio-checkbox"
          @change="change"
      ></b-form-radio>
    </div>
  </stat-box>
</template>

<script>
import StatBox from '@/components/Dashboard/StatBox';

export default {
  name: "RadioStatBox",
  components: {
    StatBox,
  },
  props: {
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    bgColor: {
      type: String,
    },
    labelColor: {
      type: String,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    cssClass: {
      type: String,
    },
    icon: {
      type: String,
    },
    info: {
      type: String,
    },
    size: {
      type: String,
    },
    align: {
      type: String,
    },
    radioName: {
      type: [String, Number],
    },
    radioValue: {
      type: [String, Number, Boolean],
      default: true,
    },
    radioChecked: {
      type: [String, Number, Boolean],
      default: 0,
    },
    radioModel: {
      type: [String, Number, Object, Array, Boolean],
    },
    divider: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      checked: false,
    }
  },
  created() {
    this.checked = this.radioChecked;
  },
  methods: {
    change(event) {
      this.checked = event;

      this.$emit(
          'change',
          { name: this.radioName, value: this.checked }
      );
    },
  }
}
</script>

<style lang="scss" scoped>
.radio-value {
  min-width: 54px;
}

.radio-checkbox {
  margin-left: 1rem !important;
  top: -6px;
}
</style>
